'use client';

import { PropsWithChildren } from 'react';
import { ExclamationmarkSmallCircleIcon } from '@zep-us/zus-icons';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { Colors } from '@zep/ui-tokens';
import { ChevronRightIcon } from '../../../../../icons';
import S from './index.module.scss';
export const AppUploadGuide = () => {
  const {
    t,
    i18n: {
      resolvedLanguage
    }
  } = useTranslation(['common', 'accounts']);
  const link = resolvedLanguage === 'ko' ? 'https://docs-kr.zep.us/creator/zep-script-guide/dev-guide/zep-script' : 'https://docs.zep.us/zep-script/zep-script-guide/zep-script-development-guide/zep-script-deployment-guide';
  return <div className={S.upload_guide} data-sentry-component="AppUploadGuide" data-sentry-source-file="index.tsx">
      <div>
        <ExclamationmarkSmallCircleIcon width={20} height={20} data-sentry-element="ExclamationmarkSmallCircleIcon" data-sentry-source-file="index.tsx" />
        {t('accounts:myApp.upload.guideNotice')}
      </div>
      <div>
        <Link href={link} target={'_blank'} prefetch={false} data-sentry-element="Link" data-sentry-source-file="index.tsx">
          {t('accounts:myApp.upload.guideLink')}
          <ChevronRightIcon fill={Colors.PrimaryDefault} width={18} height={18} data-sentry-element="ChevronRightIcon" data-sentry-source-file="index.tsx" />
        </Link>
      </div>
    </div>;
};
export const MyAppWrapper = (props: PropsWithChildren) => {
  return <div className={S.wrapper} data-sentry-component="MyAppWrapper" data-sentry-source-file="index.tsx">{props.children}</div>;
};